import { render } from "./Graph2.vue?vue&type=template&id=2ccc38b3&scoped=true&ts=true"
import script from "./Graph2.vue?vue&type=script&lang=ts"
export * from "./Graph2.vue?vue&type=script&lang=ts"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccc38b3"]])

export default __exports__